/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createResendSalesRepWelcomeResponseFromDiscriminatorValue, serializeResendSalesRepWelcomeRequest, serializeResendSalesRepWelcomeResponse, type ErrorResponse, type InternalErrorResponse, type ResendSalesRepWelcomeRequest, type ResendSalesRepWelcomeResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/resend-welcome
 */
export interface ResendWelcomeRequestBuilder extends BaseRequestBuilder<ResendWelcomeRequestBuilder> {
    /**
     * Resends the welcome email to a sales rep in the organization. Reps who have never signed in get the new-to-platform onboarding email (App Store download + first-time password setup); reps who already sign in get the standard added-to-organization email.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ResendSalesRepWelcomeResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ResendSalesRepWelcomeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ResendSalesRepWelcomeResponse | undefined>;
    /**
     * Resends the welcome email to a sales rep in the organization. Reps who have never signed in get the new-to-platform onboarding email (App Store download + first-time password setup); reps who already sign in get the standard added-to-organization email.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ResendSalesRepWelcomeRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ResendWelcomeRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/resend-welcome";
/**
 * Metadata for all the requests in the request builder.
 */
export const ResendWelcomeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ResendWelcomeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createResendSalesRepWelcomeResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeResendSalesRepWelcomeRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
